let users = [
    {
        id: 5,
        name: 'John Doe',
      photo_url: `${process.env.PUBLIC_URL}/assets/images/avatars/user-2.jpg`
    },
    {
        id: 6,
        name: 'Smith Lee',
       photo_url: `${process.env.PUBLIC_URL}/assets/images/avatars/user-3.jpg`,
    },
    {
        id: 7,
        name: 'Lisa Roy',
       photo_url: `${process.env.PUBLIC_URL}/assets/images/avatars/user-4.jpg`,
    },
    {
        id: 8,
        name: 'Lusile Beck',
       photo_url: `${process.env.PUBLIC_URL}/assets/images/avatars/user-5.jpg`,
    }
];

export default users;